export const returnCalculatedGross = (amount) => amount * 0.01
export const returnCalculatedTax = (amount) => amount * 0.01 * 0.2
export const returnV2CalculatedTax = (amount) => amount * 0.2
export const formatAmount = (amount) => `£${amount.toFixed(2)}`
export const convertPenceAmountToPounds = (amount) =>
  `£${(amount / 100).toFixed(2)}`
